import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { NavigationService } from '../../services/navigation.service';
import { SidenavItem } from './sidenav-item/sidenav-item';
import { SidenavUserMenu } from './sidenav-user-menu/sidenav-user-menu';

@Component({
  selector: 'app-sidenav',
  imports: [
    CommonModule, 
    SidenavItem, 
    SidenavUserMenu
  ],
  templateUrl: './sidenav.html',
  styleUrl: './sidenav.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Sidenav {

  private navigationService = inject(NavigationService);
  private layoutService = inject(LayoutService);

  expanded = input<boolean>(true);
  
  items = toSignal(this.navigationService.sidenavItems$, { initialValue: [] });
  navigationGroups = toSignal(this.navigationService.sidenavGroups$, { initialValue: [] });
  isMobile = this.layoutService.isMobile;
}
